import React, { SVGProps } from 'react'
const SvgSidenavBudgetsActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="m16.15 15.166-.329-.19-.01.015c-.278.382-.694.89-1.25 1.399-1.111 1.017-2.818 2.07-5.11 2.07a7.91 7.91 0 0 1-.676-15.793v-.275c0-.467.38-.855.86-.85a8.932 8.932 0 0 1 7.68 13.305.849.849 0 0 1-1.165.32Zm-1.637-.943c-.23.304-.553.683-.965 1.06-.934.856-2.296 1.676-4.097 1.676a6.41 6.41 0 0 1-.75-12.777v6.308a.85.85 0 0 0 .437.743l5.375 2.99Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavBudgetsActive
